import React, { useState, useEffect } from 'react';
import css from './Query.less';
import _ from 'lodash';
import { PopOver, Checkbox } from '@/src/components/Antd';
import { DownOutlined } from '@ant-design/icons';
// import { Select, Button, Tag, Menu } from 'antd'

const SelectionFilter = (props) => {
  const { item, index, overlayClick, filterData = [] } = props;
  const [checked, setChecked] = useState([]);
  const popClick = (list, index) => {
    const checkedList = _.cloneDeep(checked);
    const keyList = checked.map((list) => list.key);
    const _checkedAll = _.cloneDeep(checked);
    const checkedIndex = keyList.indexOf(list.key);
    if (checkedIndex > -1) {
      checkedList.splice(checkedIndex, 1);
      _checkedAll.splice(checkedIndex, 1);
    } else {
      checkedList.push(list);
      _checkedAll.push(list);
    }
    overlayClick(_checkedAll);
    setChecked(checkedList);
    // setCheckedAll(_checkedAll);
  };

  const overlay = (item, index) => (
    <div className={css.queryOverlay}>
      {(item || []).map((list) => {
        const keyList = checked.map((list) => list.key);
        return (
          <div className={css.overlaylist} key={`${list.key}-${index}`}>
            <Checkbox
              onChange={() => popClick(list, index)}
              checked={keyList.indexOf(list.key) > -1}>
              {list.name}
            </Checkbox>
          </div>
        );
      })}
    </div>
  );
  useEffect(() => {
    setChecked(filterData);
  }, [filterData]);
  return (
    <PopOver
      className={css.filterDrop}
      key={index}
      overlayClassName={css.popOverStyle}
      overlay={overlay(item.data, index)}
      placement='bottom'
      trigger={['click']}>
      <a className={css.BulkEdit} onClick={(e) => e.preventDefault()}>
        {item.name} <DownOutlined />
      </a>
    </PopOver>
  );
};
export default SelectionFilter;
